var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputFormContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 191,
    viewBox: "0 0 427 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.588837 1.0517H425.664",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.588837 37.5305H425.664",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.588837 74.0092H425.664",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.588837 110.488H425.664",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 146.967H425.664",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 183.445H425.664",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.588837 184.446V190.447",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4348 184.446V190.447",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.281 184.446V190.447",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.127 184.446V190.447",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M283.972 184.446V190.447",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M354.818 184.446V190.447",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M425.664 184.446V190.447",
    stroke: "#E0E0E0",
    strokeWidth: 0.977381
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputFormContainer);
export default __webpack_public_path__ + "static/media/input-form-container.51ed6db8aa7943ca3497812a0821d8f2.svg";
export { ForwardRef as ReactComponent };